import React, { Children } from 'react';

const CardRecentOrders = ({ children, heading, link , setSlotsModal }) => (
    <div className="ps-card Order-card-1">
        <div className="ps-card__header pb-4">
            <h4> {heading}</h4>
        </div>

        <div className="ps-card__content my-2">
            {/* <TableOrderSummary data={data} /> */}
                {children}
        </div>
        
    </div>
);

export default CardRecentOrders;
